/******************************************************
 *                  Validation
 ********************************************************/

"use strict";

import dayjs from "dayjs";

angular.module("exploitation")

	.controller("ValidationCtrl", [
		"exportTemplates", "$scope", "toastr", "$uibModal", "ValidationService", "$controller", "AdminClientsService", "AdminConsumersService", "Utils", "AdminExportTemplatesService", "ExploitTimetablesService", "$location", "$timeout", "$http", "ENV", "ExploitationService", "$window",
		function (exportTemplates, $scope, toastr, $uibModal, ValidationService, $controller, AdminClientsService, AdminConsumersService, Utils, AdminExportTemplatesService, ExploitTimetablesService, $location, $timeout, $http, ENV, ExploitationService, $window) {

		$controller("JobsCtrlParent", {$scope: $scope});

		$scope.data = {
			validations: [],
			exportTemplates: exportTemplates? exportTemplates.data: [],
			preProdData : {
				startDate : null,
				endDate : null,
				nbOfLines : null,
				nbOfQuays : null,
				nbOfStopPlaces : null,
				nbOfVehicleJourneys : null,
				nbOfCalendars : null,
				nbOfJourneyPatterns : null
			},
			prodData : {
				startDate : null,
				endDate : null,
				nbOfLines : null,
				nbOfQuays : null,
				nbOfStopPlaces : null,
				nbOfVehicleJourneys : null,
				nbOfCalendars : null,
				nbOfJourneyPatterns : null
			},
			circularReferenceCheckInProgress: true,
			isCircularReferenceErrors: false,
			isValidationLaunched: false,
			launchDate: null,
			shouldDisplayInfoTile: true,
			hasOpendatasoftConsumers: false,
            enableTransportationPlanStorage: false,
            latestStorageTime: null,
            restorationStorageTime: null,
			nextScheduledValidation: null,
		};

		$scope.formData = {
			scheduleValidationExport: false,
			scheduleValidationExportDate: null
		};

		let allLines = [];
		let refId, timeoutValidationData;
		let opendatasoftModal;
		let exportValidationScheduleModal;


		ExploitationService.getCircularReferenceCount().then((response) => {
			const data = response.data;
			$scope.data.circularReferenceCheckInProgress = false;
			if (data !== undefined && data !== null && data > 0){
				$scope.data.isCircularReferenceErrors = true;
			}

		}).catch(() => {
			$scope.data.circularReferenceCheckInProgress = false;
		});


		AdminExportTemplatesService.getAll().then((response) => {
			const data = response.data;
			if (data) {
				for (const currExport of data) {
					if (currExport.exportEnabled === false){
						continue;
					}

					if (currExport.consumers != undefined){
						for (const currConsumer of currExport.consumers) {
							if (currConsumer.type === "OPENDATASOFT"){
								$scope.data.hasOpendatasoftConsumers = true;
							}
						}
					}
				}
			}
		});

		let loadNextScheduledValidationDate = async () => {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				ValidationService.getNextScheduledValidationExport(referential.id).then((resp) => {
					var nextScheduledValidation = dayjs(resp.data.validationSchedule)
					if (nextScheduledValidation.isValid()) {
						$scope.data.nextScheduledValidation = nextScheduledValidation;
					}
				})
			});
		}

		loadNextScheduledValidationDate();


//////////////////////////////////////////////////
///////////OTHER FUNCTIONS
//////////////////////////////////////////////////

		let formatDate = function (inputDate) {
			let month = inputDate.getMonth() + 1;
			let monthText = "";

			if (month < 10){
				monthText = "0" + month;
			}else{
				monthText = month;
			}
			return inputDate.getDate() + "/" + monthText  + "/" + inputDate.getFullYear();
		}

		/*
		 * Récupère toutes les exclusions, pour regarder s'il existe une date supérieure à la date du jour
		*/
		let checkCalendarExclusions = function () {
			ExploitTimetablesService.getAllTimetables(undefined,undefined,undefined)
				.then((response) => {
					const data = response.data;
					if (data.list != undefined){
						const test = data.list[0];
						if(data.list.find(calendarDays => isDayInCalendarAfterToday(calendarDays))){
							$scope.expiredOfferMsg = undefined;
						}
					}
				});
		};


		/*
		 * Checke s'il existe, dans ce calendrier, une date supérieure à l'heure du jour
		*/
		let isDayInCalendarAfterToday = function (calendar) {
			return calendar.calendarDays.find(calendarDay => isCalendarDayAfterToday(calendarDay)) != undefined;
		};

		/*
		 * Checke si la date est de type included et si elle est supérieure à la date du jour
		*/
		let isCalendarDayAfterToday = function (calendarDay) {
			return calendarDay.included && new Date(calendarDay.date) > new Date();
		};

		/**
		 * Récupérer les infos des schemas de l'organisation
		 * @returns {*}
		 */
		let getSchemaInformations = function() {
			return $http.get(ENV.API_URL + "/admin/schemas/schema-info");
		}


		/*
 		* Récupère l'état de la dernière validation du référentiel courant
		*/
		let getValidationData = function () {
			ValidationService.getLatestValidation(refId)
				.then((response) => {
					const data = response.data;
					// on ne prend en compte que les évènements  impliqués dans la validation
					if (data && data.length > 0) {
						let events = $scope.validationEvents(data[0].events);
						const lastValidationEvent = events.sort((e1,e2)=>e2.date-e1.date)[0];
						const firstValidationEvent = events.filter(e => e.state === "STARTED").sort((e1,e2)=>e1.date-e2.date)[0];
						data[0].events = events;
						if (lastValidationEvent) {
							data[0].endState = lastValidationEvent.state;
							data[0].lastEvent = lastValidationEvent.date;
						}
						if (firstValidationEvent) {
							data[0].firstEvent = firstValidationEvent.date;
						}
					}

					if (data !== undefined && data.length > 0){
						let firstEvent = new Date(data[0].firstEvent);
						$scope.data.validations = data;
						if (firstEvent > $scope.data.launchDate){
							$scope.data.shouldDisplayInfoTile = true;
						}

					}
					timeoutValidationData = $timeout(() => getValidationData(), 5000);
				})
				.catch(function () {
					timeoutValidationData = $timeout(() => getValidationData(), 5000);
				});

		};

		let launchValidation = function() {
			$scope.data.isValidationLaunched = true;
			$scope.data.shouldDisplayInfoTile = false;

			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				ValidationService.validate(referential.id, referential.user)
					.then(() => toastr.success("", "Validation démarrée"))
					.catch(() => toastr.error("Problème lors de la validation")
				);
			});

		};

//////////////////////////////////////////////////
///////////SCOPE FUNCTIONS
//////////////////////////////////////////////////



		$scope.$on('$destroy', function (e) {
			$timeout.cancel(timeoutValidationData);
		});

		$scope.validate = function () {

			$scope.data.launchDate = new Date();


			if ($scope.data.circularReferenceCheckInProgress){
				toastr.info("Veuillez patienter pendant le controle", "Contrôle en cours");
				return;
			}

			if ($scope.data.isCircularReferenceErrors){
				toastr.error("Veuillez contacter votre administrateur, des points d'arrêt font référence à eux même.", "Validation impossible");
				return;
			}

			if ($scope.data.hasOpendatasoftConsumers){
				opendatasoftModal = Utils.openModal($uibModal, "opendatasoftModal.html", $scope);
				return;
			}
			launchValidation();
		};

		$scope.validateOpendatasoftModal = function () {
				opendatasoftModal.close();
				AdminConsumersService.updateOpendatasoftInfos($scope.data.exportDate, $scope.data.description);
				launchValidation();
		};

		/**
		 * Renvoie les évènements concernant la validation
		 */
		$scope.validationEvents = function(events) {
			return events.length > 0 ? events.filter(e => $scope.isValidationEvent(e)) : [];
		};

		$scope.openScheduleValidationExportModal = function () {
			exportValidationScheduleModal = Utils.openModal($uibModal, "scheduleValidationExportModal.html", $scope);
		}

		$scope.submitScheduleValidationExportForm = function ($event) {
			if (!$scope.validateScheduleValidationExportForm($event)) {
				return;
			}
			exportValidationScheduleModal.close();
			if ($scope.formData.scheduleValidationExport) {
				AdminClientsService.getReferentialId().then((refId) =>
					ValidationService.scheduleManualValidationExport(refId, $scope.formData.scheduleValidationExportDate)
						 .then((resp) => {
							 toastr.success(`Validation planifiée le ${$scope.formData.scheduleValidationExportDate} avec succès`);
							 loadNextScheduledValidationDate();
						 })
						 .catch((error) => toastr.error("Problème lors de la planification de la validation"))
				)
			} else {
				$scope.validate()
			}
		}

		$scope.validateScheduleValidationExportForm = function ($event) {
			if (!$scope.formData.scheduleValidationExport) {
				return true;
			}
			if (!$scope.formData.scheduleValidationExportDate) {
				toastr.error("La date de planification est obligatoire", "Erreur");
				return false;
			}
			if (Date.now() >= $scope.formData.scheduleValidationExportDate.getTime()) {
				toastr.error("La date de planification doit être dans le futur", "Erreur");
				return false;
			}
			return true;
		}

		/**
		 * Détermine si un évènement impliqué dans la validation
		 */
		$scope.isValidationEvent = function(event) {
			return event.action.indexOf("VALIDATION_") === 0 || "DATASPACE_TRANSFER" === event.action;
		};

		$scope.isLineInExport = function(line, exp) {
			return exp.lines && exp.lines.find(l => l.id === line.id) !== undefined;
		};


		$scope.goToExportsPage = function () {
			$location.path("data-management/exports/");
		};

		$scope.openDate = function ($event) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.datadatestart.dateOpened = true;
		};

		/**
		 * Retourne la couleur du texte de la ligne
		 * @param line
		 * @returns {string}
		 */
		$scope.getLineTextColor = function (line) {
			if (!line || !line.textColor || (line.textColor === "000000" && line.color === "000000")) {
				return "#FFFFFF";
			} else if (line.textColor === line.color) {
				return "#000000";
			} else {
				return "#" + line.textColor;
			}
		};

		/**
		 * Retourne la couleur de fond de la ligne
		 * @param line
		 * @returns {string}
		 */
		$scope.getLineBackgroundColor = function (line) {
			if (!line){
				return "#FFFFFF";
			}
			return "#" + line.color;
		};

		let restoreReferentialModal;

        $scope.restoreReferential = function () {
			restoreReferentialModal = Utils.openModal($uibModal, "restoreReferential.html", $scope);
        }

		$scope.validateRestoreReferentialModal = function () {
			ValidationService.restoreReferential(AdminClientsService.getCurrentReferential())
				.then(() => {
				 	toastr.success("Le référential a bien été restauré");
				})
				.catch((response) => {
					 const data = response.data;
					 let errorMessage = "Problème lors de la restauration du référentiel.";
					 if (data !== undefined && data.message) {
						 errorMessage += "\n" + data.message;
					 }
					 toastr.error(errorMessage, "Erreur");
				})
				.finally(() => {
					restoreReferentialModal.close();
				});
		}

//////////////////////////////////////////////////
///////////PAGE INITIALIZATION
//////////////////////////////////////////////////

		$scope.data.exportTemplates.forEach(exp => {
			if (exp.lines) {
				const filtered = exp.lines.filter(l => !allLines.find(li => li.id === l.id));
				allLines = allLines.concat(filtered);
			}
			exp.startDate = new Date();
		});

		$scope.data.allLines = allLines;
        $scope.data.enableTransportationPlanStorage = $window._env_.ENABLE_TRANSPORTATION_PLAN_STORAGE === "true";
        if ($scope.data.enableTransportationPlanStorage) {
            ValidationService.getRestorationStorageTime(AdminClientsService.getCurrentReferential()).then(
                (latestStorageTimeResp) => {
                    if (latestStorageTimeResp.data)
                        $scope.data.restorationStorageTime = formatDate(new Date(Number(latestStorageTimeResp.data)));
                });
            ValidationService.getLatestStorageTime(AdminClientsService.getCurrentReferential()).then(
                (latestStorageTimeResp) => {
                    if (latestStorageTimeResp.data)
                        $scope.data.latestStorageTime = formatDate(new Date(Number(latestStorageTimeResp.data)));
                });
        }

		AdminClientsService.getReferentialId().then((data) => {
			refId = data;
			getValidationData();
		});

		ExploitTimetablesService.getProductionPeriods().then((response) => {
			const data = response.data;
			if(data) {
				const maxMillis = Math.max(...data);
				const maxDate=new Date(maxMillis);
				const currentDate = new Date();
				if (currentDate > maxDate){
					$scope.expiredOfferMsg = "Votre offre a expiré. Veuillez importer une nouvelle offre.";
					checkCalendarExclusions();
				}
				$scope.data.exportTemplates.forEach(exp => {
					exp.endDate=maxDate;

				});
			}

		});



		getSchemaInformations().then((response) => {
			const data = response.data;
			if(data) {
				if (data.preProductionInfos.startDate !== null && data.preProductionInfos.startDate !== 'undefined'){
					$scope.data.preProdData.startDate = formatDate(new Date(data.preProductionInfos.startDate));
				}

				if (data.preProductionInfos.endDate !== null && data.preProductionInfos.endDate !== 'undefined'){
					$scope.data.preProdData.endDate = formatDate(new Date(data.preProductionInfos.endDate));
				}

				$scope.data.preProdData.nbOfLines = data.preProductionInfos.nbOfLines;
				$scope.data.preProdData.nbOfQuays = data.preProductionInfos.nbOfQuays;
				$scope.data.preProdData.nbOfStopPlaces = data.preProductionInfos.nbOfStopPlaces;
				$scope.data.preProdData.nbOfVehicleJourneys = data.preProductionInfos.nbOfVehicleJourneys;
				$scope.data.preProdData.nbOfCalendars = data.preProductionInfos.nbOfCalendars;
				$scope.data.preProdData.nbOfJourneyPatterns = data.preProductionInfos.nbOfJourneyPatterns;


				if (data.productionInfos.startDate !== null && data.productionInfos.startDate !== 'undefined'){
					$scope.data.prodData.startDate = formatDate(new Date(data.productionInfos.startDate));
				}

				if (data.productionInfos.endDate !== null && data.productionInfos.endDate !== 'undefined'){
					$scope.data.prodData.endDate = formatDate(new Date(data.productionInfos.endDate));
				}
				$scope.data.prodData.nbOfLines = data.productionInfos.nbOfLines;
				$scope.data.prodData.nbOfQuays = data.productionInfos.nbOfQuays;
				$scope.data.prodData.nbOfStopPlaces = data.productionInfos.nbOfStopPlaces;
				$scope.data.prodData.nbOfVehicleJourneys = data.productionInfos.nbOfVehicleJourneys;
				$scope.data.prodData.nbOfCalendars = data.productionInfos.nbOfCalendars;
				$scope.data.prodData.nbOfJourneyPatterns = data.productionInfos.nbOfJourneyPatterns;

			}

		});

	}]);
